import { useFetch } from '../lib/useFetch';
import { formatFcfa } from '../lib/labels';

interface DayRevenue {
  date: string;
  total: number;
  count: number;
}

interface DashboardStats {
  totalCommissions: number;
  commissionsToday: number;
  completedRidesToday: number;
}

export default function Revenue() {
  const revenue = useFetch<DayRevenue[]>('/admin/revenue?days=30');
  const stats = useFetch<DashboardStats>('/admin/dashboard');

  const days = revenue.data ?? [];
  const periodTotal = days.reduce((sum, d) => sum + Number(d.total || 0), 0);
  const periodRides = days.reduce((sum, d) => sum + Number(d.count || 0), 0);

  return (
    <div className="page-transition">
      <div className="container pt-6">
        <div className="page-head">
          <div>
            <h1 className="page-title">Revenus</h1>
            <p className="page-subtitle">Commissions de la plateforme (30 derniers jours)</p>
          </div>
        </div>

        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-card-header"><span className="stat-card-title">Aujourd'hui</span></div>
            <div className="stat-card-value">{stats.data ? formatFcfa(stats.data.commissionsToday) : '…'}</div>
          </div>
          <div className="stat-card">
            <div className="stat-card-header"><span className="stat-card-title">30 derniers jours</span></div>
            <div className="stat-card-value">{revenue.data ? formatFcfa(periodTotal) : '…'}</div>
          </div>
          <div className="stat-card">
            <div className="stat-card-header"><span className="stat-card-title">Courses payées (30 j)</span></div>
            <div className="stat-card-value">{revenue.data ? periodRides.toLocaleString('fr-FR') : '…'}</div>
          </div>
          <div className="stat-card">
            <div className="stat-card-header"><span className="stat-card-title">Total cumulé</span></div>
            <div className="stat-card-value">{stats.data ? formatFcfa(stats.data.totalCommissions) : '…'}</div>
          </div>
        </div>

        <div className="card">
          <h2 className="text-lg font-semibold mb-4">Détail par jour</h2>
          {revenue.isLoading ? (
            <div className="state-box"><span className="loading-spinner" /></div>
          ) : revenue.error ? (
            <div className="state-box">{revenue.error}</div>
          ) : !days.length ? (
            <div className="state-box">Aucune commission encaissée sur la période.</div>
          ) : (
            <div className="table-wrap">
              <table className="data-table">
                <thead>
                  <tr><th>Date</th><th>Courses payées</th><th>Commissions</th></tr>
                </thead>
                <tbody>
                  {days.map(d => (
                    <tr key={String(d.date)}>
                      <td>{new Date(String(d.date)).toLocaleDateString('fr-FR')}</td>
                      <td>{d.count}</td>
                      <td><strong>{formatFcfa(d.total)}</strong></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
